import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AvaliacaoService {
  context = '/avaliacoes';
  constructor(private apiService: ApiService) {}

  add(avaliacao: any): Observable<any> {
    return this.apiService.post(`${this.context}`, avaliacao);
  }

  getAll(limit?: number): Observable<any[]> {
    const path = limit ? `${this.context}/&limit=${limit}` : `${this.context}`;
    return this.apiService.get(path);
  }

  getById(id: number): Observable<any> {
    return this.apiService.get(`${this.context}?curso=${id}`);
  }

  update(avaliacao: any): Observable<any> {
    const { id } = avaliacao;
    return this.apiService.put(`${this.context}/${id}`, avaliacao);
  }

  delete(id: number) {
    return this.apiService.delete(`${this.context}/${id}`);
  }
}
